///dataimportexport/import/opportunity
export const DATA_IMPORT_OPPORTUNITY = "DATA_IMPORT_OPPORTUNITY";
export const DATA_IMPORT_OPPORTUNITY_SUCCESS =
  "DATA_IMPORT_OPPORTUNITY_SUCCESS";
export const DATA_IMPORT_OPPORTUNITY_FAILURE =
  "DATA_IMPORT_OPPORTUNITY_FAILURE";

///dataimportexport/import/schema
export const DATA_IMPORT_SCHEMA = "DATA_IMPORT_SCHEMA";
export const DATA_IMPORT_SCHEMA_SUCCESS = "DATA_IMPORT_SCHEMA_SUCCESS";
export const DATA_IMPORT_SCHEMA_FAILURE = "DATA_IMPORT_SCHEMA_FAILURE";

///dataimportexport/import
export const DATA_IMPORT = "DATA_IMPORT";
export const DATA_IMPORT_SUCCESS = "DATA_IMPORT_SUCCESS";
export const DATA_IMPORT_FAILURE = "DATA_IMPORT_FAILURE";
// reset the import result (clear toast/result state between runs)
export const DATA_IMPORT_RESET = "DATA_IMPORT_RESET";

///dataimportexport/import/ai_reshape
export const DATA_IMPORT_RESHAPE = "DATA_IMPORT_RESHAPE";
export const DATA_IMPORT_RESHAPE_SUCCESS = "DATA_IMPORT_RESHAPE_SUCCESS";
export const DATA_IMPORT_RESHAPE_FAILURE = "DATA_IMPORT_RESHAPE_FAILURE";
// clear the reshape result/error (e.g. on re-run or leaving the step)
export const DATA_IMPORT_RESHAPE_RESET = "DATA_IMPORT_RESHAPE_RESET";
